import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { getUserAsAdmin } from '../../../../services/user';

import './style.scss';

const FlaggedLinks = (props) => {
  const {
    deleteFlaggedLink,
    flaggedLinks,
  } = props;

  const [foundUsers, setFoundUsers] = useState([]);

  useEffect(() => {
    (async () => {
      const userIds = [...new Set(flaggedLinks.map(link => link.user))];
      const users = await Promise.all(userIds.map(id => getUserAsAdmin(id)));

      setFoundUsers(users.reduce((acc, curr) => ({
        ...acc,
        [curr._id]: curr,
      }), {}));
    })();
  }, [flaggedLinks]);

  const unflagLink = linkId => deleteFlaggedLink(linkId);

  return (
    <div id="admin-content">
      <h1>Admin Portal</h1>
      <Link className="admin-home-button" to="/admin">Go To Admin Home</Link>
      <div id="flagged-links-container" className="admin-container">
        <h3>Flagged Links</h3>
        <ul>
          {flaggedLinks.map(l => (
            <li key={l.link}>
              <a href={l.link} target="_blank" rel="noopener noreferrer">{l.link}</a>
              <p>Reported By: {foundUsers[l.user] ? `${foundUsers[l.user].first_name} ${foundUsers[l.user].last_name}` : l.user}</p>
              <button type="button" onClick={() => unflagLink(l._id)}>Unflag Link</button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FlaggedLinks;
